export default __webpack_public_path__ + "static/media/Footpad's Leggings of the Tenth Court.ba0c8ec2.jpg";